var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgListChecklist = function SvgListChecklist(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "list_checklist_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#list_checklist_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4277FC",
    d: "M19.76 25.625q-.768 0-1.321-.554-.555-.555-.554-1.321v-5.24q0-.768.554-1.321.555-.554 1.32-.554H25q.767 0 1.32.554.555.555.555 1.32v5.241q0 .767-.554 1.32-.555.555-1.321.555zm0-1.875H25v-5.24h-5.24zM4.062 22.067a.9.9 0 0 1-.667-.27.9.9 0 0 1-.27-.668q0-.399.27-.667.27-.27.668-.27h8.894q.398 0 .668.27t.27.668q0 .4-.27.668a.9.9 0 0 1-.668.27zm15.698-8.702q-.768 0-1.321-.554-.555-.555-.554-1.32V6.25q0-.767.554-1.32.555-.555 1.32-.555H25q.767 0 1.32.554.555.555.555 1.321v5.24q0 .768-.554 1.321-.555.555-1.321.554zm0-1.875H25V6.25h-5.24zM4.062 9.808a.9.9 0 0 1-.667-.27.9.9 0 0 1-.27-.668q0-.4.27-.668.27-.27.668-.27h8.894q.398 0 .668.27t.27.669-.27.667a.9.9 0 0 1-.668.27z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgListChecklist);
export default ForwardRef;